import { render, staticRenderFns } from "./LastVotersClusterPrefix.vue?vue&type=template&id=16ac9a96&scoped=true&"
import script from "./LastVotersClusterPrefix.vue?vue&type=script&lang=js&"
export * from "./LastVotersClusterPrefix.vue?vue&type=script&lang=js&"
import style0 from "./LastVotersClusterPrefix.vue?vue&type=style&index=0&id=16ac9a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac9a96",
  null
  
)

export default component.exports